export const BULK_UPDATE_EMPLOYEES_ACTION = "BULK_UPDATE_EMPLOYEES_ACTION"
export const BULK_UPDATE_EMPLOYEES_LOADING = "BULK_UPDATE_EMPLOYEES_ACTION"
export const BULK_UPDATE_EMPLOYEES_SUCCESS = "BULK_UPDATE_EMPLOYEES_ACTION"
export const BULK_UPDATE_EMPLOYEES_ERROR = "BULK_UPDATE_EMPLOYEES_ACTION"

export const ONBOARD_EMPLOYEES_ACTION = "ONBOARD_EMPLOYEES_ACTION";
export const ONBOARD_EMPLOYEES_LOADING = "ONBOARD_EMPLOYEES_LOADING";
export const ONBOARD_EMPLOYEES_SUCCESS = "ONBOARD_EMPLOYEES_SUCCESS";
export const ONBOARD_EMPLOYEES_ERROR = "ONBOARD_EMPLOYEES_ERROR";

export const ONBOARD_EMPLOYEES_VERIFY_ACTION = "ONBOARD_EMPLOYEES_VERIFY_ACTION";
export const ONBOARD_EMPLOYEES_VERIFY_LOADING = "ONBOARD_EMPLOYEES_VERIFY_LOADING";
export const ONBOARD_EMPLOYEES_VERIFY_SUCCESS = "ONBOARD_EMPLOYEES_VERIFY_SUCCESS";
export const ONBOARD_EMPLOYEES_VERIFY_ERROR = "ONBOARD_EMPLOYEES_VERIFY_ERROR";

export const INVITE_EMPLOYEES_ACTION = "INVITE_EMPLOYEES_ACTION";
export const INVITE_EMPLOYEES_LOADING = "INVITE_EMPLOYEES_LOADING";
export const INVITE_EMPLOYEES_SUCCESS = "INVITE_EMPLOYEES_SUCCESS";
export const INVITE_EMPLOYEES_ERROR = "INVITE_EMPLOYEES_ERROR";

export const INVITE_PENDING_EMPLOYEES_ACTION = "INVITE_PENDING_EMPLOYEES_ACTION";
export const INVITE_PENDING_EMPLOYEES_LOADING = "INVITE_PENDING_EMPLOYEES_LOADING";
export const INVITE_PENDING_EMPLOYEES_SUCCESS = "INVITE_PENDING_EMPLOYEES_SUCCESS";
export const INVITE_PENDING_EMPLOYEES_ERROR = "INVITE_PENDING_EMPLOYEES_ERROR";

export const UPDATE_EMPLOYEE_ACTION = "UPDATE_EMPLOYEE_ACTION";
export const UPDATE_EMPLOYEE_LOADING = "UPDATE_EMPLOYEE_LOADING";
export const UPDATE_EMPLOYEE_SUCCESS = "UPDATE_EMPLOYEE_SUCCESS";
export const UPDATE_EMPLOYEE_ERROR = "UPDATE_EMPLOYEE_ERROR";

export const CREATE_PAYSTACK_PROFILE_ACTION = "CREATE_PAYSTACK_PROFILE_ACTION";
export const CREATE_PAYSTACK_PROFILE_LOADING = "CREATE_PAYSTACK_PROFILE_LOADING";
export const CREATE_PAYSTACK_PROFILE_SUCCESS = "CREATE_PAYSTACK_PROFILE_SUCCESS";
export const CREATE_PAYSTACK_PROFILE_ERROR = "CREATE_PAYSTACK_PROFILE_ERROR";

export const OVERTIME_LIST_ACTION = "OVERTIME_LIST_ACTION";
export const OVERTIME_LIST_LOADING = "OVERTIME_LIST_LOADING";
export const OVERTIME_LIST_SUCCESS = "OVERTIME_LIST_SUCCESS";
export const OVERTIME_LIST_ERROR = "OVERTIME_LIST_ERROR";

export const GET_OVERTIME_ACTION = "GET_OVERTIME_ACTION";
export const GET_OVERTIME_LOADING = "GET_OVERTIME_LOADING";
export const GET_OVERTIME_SUCCESS = "GET_OVERTIME_SUCCESS";
export const GET_OVERTIME_ERROR = "GET_OVERTIME_ERROR";

export const APPROVE_OVERTIME_ACTION = "APPROVE_OVERTIME_ACTION";
export const APPROVE_OVERTIME_LOADING = "APPROVE_OVERTIME_LOADING";
export const APPROVE_OVERTIME_SUCCESS = "APPROVE_OVERTIME_SUCCESS";
export const APPROVE_OVERTIME_ERROR = "APPROVE_OVERTIME_ERROR";

export const REJECT_OVERTIME_ACTION = "REJECT_OVERTIME_ACTION";
export const REJECT_OVERTIME_LOADING = "REJECT_OVERTIME_LOADING";
export const REJECT_OVERTIME_SUCCESS = "REJECT_OVERTIME_SUCCESS";
export const REJECT_OVERTIME_ERROR = "REJECT_OVERTIME_ERROR";

export const LEAVE_LIST_ACTION = "LEAVE_LIST_ACTION";
export const LEAVE_LIST_LOADING = "LEAVE_LIST_LOADING";
export const LEAVE_LIST_SUCCESS = "LEAVE_LIST_SUCCESS";
export const LEAVE_LIST_ERROR = "LEAVE_LIST_ERROR";

export const CREATE_LEAVE_ACTION = "CREATE_LEAVE_ACTION";
export const CREATE_LEAVE_LOADING = "CREATE_LEAVE_LOADING";
export const CREATE_LEAVE_SUCCESS = "CREATE_LEAVE_SUCCESS";
export const CREATE_LEAVE_ERROR = "CREATE_LEAVE_ERROR";

export const GET_COMPANY_PAYMENT_ACTION = "GET_COMPANY_PAYMENT_ACTION";
export const GET_COMPANY_PAYMENT_LOADING = "GET_COMPANY_PAYMENT_LOADING";
export const GET_COMPANY_PAYMENT_SUCCESS = "GET_COMPANY_PAYMENT_SUCCESS";
export const GET_COMPANY_PAYMENT_ERROR = "GET_COMPANY_PAYMENT_ERROR";


export const GET_WITHDRAWAL_CATEGORIES_ACTION = "GET_ADMIN_WITHDRAWAL_CATEGORIES_ACTION";
export const GET_WITHDRAWAL_CATEGORIES_LOADING = "GET_ADMIN_WITHDRAWAL_CATEGORIES_LOADING";
export const GET_WITHDRAWAL_CATEGORIES_ERROR = "GET_ADMIN_WITHDRAWAL_CATEGORIES_ERROR";
export const GET_WITHDRAWAL_CATEGORIES_SUCCESS = "GET_ADMIN_WITHDRAWAL_CATEGORIES_SUCCESS";

export const {
    EMPLOYEE_COMPANY_JOIN_REQUEST_ACTION,
    EMPLOYEE_COMPANY_JOIN_REQUEST_LOADING,
    EMPLOYEE_COMPANY_JOIN_REQUEST_SUCCESS,
    EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR,
    EMPLOYEE_COMPANY_JOIN_REQUEST_DETAIL_ACTION,
    EMPLOYEE_COMPANY_JOIN_REQUEST_DETAIL_LOADING,
    EMPLOYEE_COMPANY_JOIN_REQUEST_DETAIL_SUCCESS,
    EMPLOYEE_COMPANY_JOIN_REQUEST_DETAIL_ERROR,
    EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_ACTION,
    EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_LOADING,
    EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_SUCCESS,
    EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_ERROR,
    EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_ACTION,
    EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_LOADING,
    EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_SUCCESS,
    EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_ERROR,
    EMPLOYEE_COMPANY_JOIN_REQUEST_EDIT_ACTION,
    EMPLOYEE_COMPANY_JOIN_REQUEST_EDIT_LOADING,
    EMPLOYEE_COMPANY_JOIN_REQUEST_EDIT_SUCCESS,
    EMPLOYEE_COMPANY_JOIN_REQUEST_EDIT_ERROR,
    LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_ACTION,
    LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_LOADING,
    LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_SUCCESS,
    LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR,
    UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ACTION,
    UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_LOADING,
    UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_SUCCESS,
    UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR,
    LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_ACTION,
    LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_LOADING,
    LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_SUCCESS,
    LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_ERROR,
    INVITE_COMPANY_ADMIN_ACTION,
    INVITE_COMPANY_ADMIN_LOADING,
    INVITE_COMPANY_ADMIN_SUCCESS,
    INVITE_COMPANY_ADMIN_ERROR,
    CHANGE_EMPLOYEE_PERMISSION_ACTION,
    CHANGE_EMPLOYEE_PERMISSION_LOADING,
    CHANGE_EMPLOYEE_PERMISSION_SUCCESS,
    CHANGE_EMPLOYEE_PERMISSION_ERROR
} = buildTypeConstants([
    "EMPLOYEE_COMPANY_JOIN_REQUEST",
    "EMPLOYEE_COMPANY_JOIN_REQUEST_DETAIL",
    "EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE",
    "EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT",
    "EMPLOYEE_COMPANY_JOIN_REQUEST_EDIT",
    "LIST_EMPLOYEE_COMPANY_JOIN_REQUEST",
    "UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST",
    "LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS",
    "INVITE_COMPANY_ADMIN",
    "CHANGE_EMPLOYEE_PERMISSION"
]);

export function buildTypeConstants(constants = []) {
    const obj = {}
    constants.forEach(function (value) {
        value = value.toUpperCase();
        let key = value.toUpperCase();
        const konst = [
            "_ACTION",
            "_LOADING",
            "_ERROR",
            "_SUCCESS"
        ]
        konst.forEach(function (k) {
            obj[value + k] = value + k;
        })

    })
    return obj;
}


